const components = require('./build');
module.exports = components;
